<template>
	<label class="mc-checkbox" :class="{'is-disabled': disabled}">
		<span class="mc-checkbox__input">
			<span class="mc-checkbox__inner" :class="{'is-checked': currentValue, 'is-disabled': disabled}">
				<i class="fa fa-check"></i>
			</span>
			<span class="mc-checkbox__label" :class="{'is-checked': currentValue, 'is-disabled': disabled}">
				<slot></slot>
			</span>
		    <input
		            v-if="group"
		            type="checkbox"
		            class="mc-checkbox__original"
		            :disabled="disabled"
		            :value="label"
		            v-model="model"
		            :name="name"
		            @change="change"
		            @focus="onFocus"
		            @blur="onBlur">
		    <input
		            v-else
		            type="checkbox"
		            class="mc-checkbox__original"
		            :disabled="disabled"
		            :checked="currentValue"
		            :name="name"
		            @change="change"
		            @focus="onFocus"
		            @blur="onBlur">
		</span>
		<!--<slot><span v-if="showSlot">{{ label }}</span></slot>-->
	</label>
</template>
<script>
    import {findComponentUpward, oneOf} from '../lib/assist';
    import Emitter from '../mixins/emitter';

    const prefixCls = 'ivu-checkbox';

    export default {
        name: 'Checkbox',
        mixins: [Emitter],
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            trueValue: {
                type: [String, Number, Boolean],
                default: true
            },
            falseValue: {
                type: [String, Number, Boolean],
                default: false
            },
            label: {
                type: [String, Number, Boolean]
            },
            indeterminate: {
                type: Boolean,
                default: false
            },
            size: {
                validator(value) {
                    return oneOf(value, ['small', 'large', 'default']);
                }
            },
            name: {
                type: String
            }
        },
        data() {
            return {
                model: [],
                currentValue: this.value,
                group: false,
                showSlot: true,
                parent: findComponentUpward(this, 'CheckboxGroup'),
                focusInner: false
            };
        },
        computed: {

        },
        mounted() {
            this.parent = findComponentUpward(this, 'CheckboxGroup');
            if (this.parent) {
                this.group = true;
            }

            if (this.group) {
                this.parent.updateModel(true);
            } else {
                this.updateModel();
                this.showSlot = this.$slots.default !== undefined;
            }
        },
        methods: {
            change(event) {
                if (this.disabled) {
                    return false;
                }

                const checked = event.target.checked;
                this.currentValue = checked;

                const value = checked ? this.trueValue : this.falseValue;
                this.$emit('input', value);
                this.$emit('change', value, event);

                if (this.group) {
                    this.parent.change(this.model);
                } else {
                    this.$emit('change', value);
                    this.dispatch('FormItem', 'on-form-change', value);
                }
            },
            updateModel() {
                this.currentValue = this.value === this.trueValue;
            },
            onBlur() {
                this.focusInner = false;
            },
            onFocus() {
                this.focusInner = true;
            }
        },
        watch: {
            value(val) {
                if (val === this.trueValue || val === this.falseValue) {
                    this.updateModel();
                } else {
                    throw 'Value should be trueValue or falseValue.';
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/base-checkbox.vue